export default __webpack_public_path__ + "static/media/Q11_2_resized.dd4345c0.jpg";